import React from 'react'

const Megaphone = ({ color, size }) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size || '16'}
      height={size || '16'}
      viewBox="0 0 16 16"
    >
      <path
        fill={color || 'white'}
        d="M0.7,5.6C0.8,5.3,1,5.2,1.3,5.3c0.4,0,0.8,0,1.2,0c0-0.1,0-0.3,0-0.4c0-0.3,0.2-0.5,0.5-0.5c1.4,0,2.9,0,4.3,0
		c0.2,0,0.4,0,0.7,0C8,6.2,8,8,8,9.8c-0.6,0-1.1,0-1.7,0c0,0,0,0.1,0.1,0.1c0.5,0.9,0.9,1.9,1.4,2.8C8,13.3,8,13.6,7.6,14
		c-0.3,0.3-0.6,0.6-0.9,0.9c-0.2,0.2-0.4,0.4-0.6,0.4c-0.1,0-0.2,0-0.3,0c-0.4-0.1-0.6-0.4-0.8-0.8c-0.4-1.2-0.9-2.5-1.4-3.7
		c-0.1-0.3-0.3-0.7-0.4-1c-0.1,0-0.2,0-0.2,0c-0.3,0-0.5-0.2-0.5-0.5c0-0.1,0-0.3,0-0.4c-0.4,0-0.8,0-1.2,0C1,8.9,0.8,8.8,0.7,8.6
		C0.7,7.6,0.7,6.6,0.7,5.6z"
      />
      <path
        fill={color || 'white'}
        d="M8.9,4.2C9.2,4.1,9.4,4.1,9.7,4c1.9-0.5,3.5-1.5,4.7-3c0.1-0.1,0.1-0.2,0.2-0.2c0.3-0.1,0.6,0.1,0.6,0.4
		c0,0,0,0.1,0,0.1c0,3.9,0,7.8,0,11.6c0,0.1,0,0.2-0.1,0.3c-0.1,0.3-0.4,0.3-0.7,0.1c0,0-0.1-0.1-0.1-0.1C13,11.6,11.2,10.5,9,10
		C9,10,8.9,10,8.9,9.9C8.9,8,8.9,6.1,8.9,4.2C8.9,4.2,8.9,4.2,8.9,4.2z"
      />
    </svg>
  )
}

export default Megaphone
